"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkoutPaymentCreator = void 0;
var consts_1 = require("../consts");
var checkoutPaymentCreator = function (event) {
    var _a, _b;
    var eventData = {
        action: 'checkout-payment',
        event: 'checkout-payment-load',
        eventInfo: 'checkout-payment-load',
        cart: {
            product: event.eventData.cart.product.map(function (item) { return (__assign(__assign({}, item), { bundledProduct: item.bundledProduct || consts_1.NOT_AVAILABLE })); }),
            sendAsGift: ((_a = event.eventData.cart) === null || _a === void 0 ? void 0 : _a.sendAsGift) || consts_1.NOT_AVAILABLE,
            checkoutType: ((_b = event.eventData.cart) === null || _b === void 0 ? void 0 : _b.checkoutType) || consts_1.DEFAULT_CHECKOUT_TYPE,
        },
    };
    return eventData;
};
exports.checkoutPaymentCreator = checkoutPaymentCreator;
